import './../../../../../style/Vars.css';
import './../../../../../style/ContainersStyles.css';
import './../../../../../style/ElementsStyle.css';
import CursosCompartidosCatalog from './CursosCompartidosCatalog';

export default function CursosCompartidosPage() {
    return <CursosCompartidosCatalog />;
}

